
import { mapState } from 'vuex'
export default {
    name: 'MenubarComponent',
    data: () => ({
        openCard: [],
        v: true,
    }),
    computed: {
        ...mapState({
            menubars: (state) => state.cms.menus.menus,
        }),
    },
}
